import useUserProfile from './useUserProfile';

const useTimeZone = () => {
    const { timeZone } = useUserProfile();

    return timeZone;
};

export default useTimeZone;
